import mixpanel, { Mixpanel } from 'mixpanel-browser'
import { config } from '../../../config'

let instance: Mixpanel
const LIBRARY_NAME = 'appointment-ui'

const init = (distinctId: string) => {
  if (instance) return instance

  const token = config.MIXPANEL_PROJECT_TOKEN

  if (!Boolean(token)) return instance

  instance = mixpanel.init(
    token,
    {
      loaded: function (mixpanel) {
        mixpanel.identify(distinctId)
      },
    },
    LIBRARY_NAME
  )

  return instance
}

const getInstance = (): Mixpanel | undefined => instance

export { init, getInstance }
